import { yupResolver } from "@hookform/resolvers/yup"
import { Box, Typography } from "@jewlr/storybook/core"
import { FloatInput } from "@jewlr/storybook/form"
import PropTypes from "prop-types"
import React, { useCallback, useState } from "react"
import { useForm, Controller } from "react-hook-form"
import { connect } from "react-redux"
import isEmail from "validator/lib/isEmail"
import * as Yup from "yup"

import { doForgotPassword } from "app-store-v2/app/actions"
import Modal, { closeModal } from "components/modal"

import { AuthenticateModalTitle, Cta } from "./components"

const schema = Yup.object().shape({
  email: Yup.string()
    .required("Please enter a valid email address.")
    .test("test-email", "Please enter a valid email address.", (value) =>
      isEmail(value || "")
    ),
})

const InternalForgotPassword = ({ forgotPassword }) => {
  const [showContent, setShowContent] = useState(false)
  const [email, setEmail] = useState("")
  const {
    control,
    formState: { errors, isSubmitting },
    handleSubmit,
    setError,
  } = useForm({
    defaultValues: { email: "" },
    mode: "onBlur",
    resolver: yupResolver(schema),
  })

  const onSubmit = async (data) => {
    try {
      await new Promise((res, rej) => {
        forgotPassword(data.email, {
          onError: (err) => rej(err),
          onSuccess: (email) => {
            setEmail(email)
            res()
          },
        })
      })
    } catch (err) {
      setError("root.error", { message: err })
    }
  }

  const afterShow = useCallback(() => {
    setShowContent(true)
  })

  return (
    <Modal afterShow={afterShow} show="#forgot-password" width="430px">
      {showContent && (
        <form onSubmit={handleSubmit(onSubmit)}>
          {email ? (
            <Box textAlign="center">
              <Typography mb={3}>
                If an account with {email} exists, you&apos;ll receive a link to
                reset your password.
              </Typography>
              <Cta onClick={closeModal}>Close</Cta>
            </Box>
          ) : (
            <Box textAlign="center">
              <AuthenticateModalTitle>
                Forgot Your Password?
              </AuthenticateModalTitle>
              <Typography mb={2}>
                Press Submit to have instructions on how to reset your password
                emailed to you.
              </Typography>
              <Box mb={2}>
                <Controller
                  control={control}
                  name="email"
                  render={({ field, fieldState: { error } }) => (
                    <FloatInput
                      data-cy="forgot-password-email-input"
                      error={error}
                      label="Email"
                      placeholder="Enter your email"
                      type="email"
                      {...field}
                    />
                  )}
                  rules={{ required: true }}
                />
              </Box>
              <Cta
                data-cy="forgot-password-submit-button"
                loading={isSubmitting}
                type="submit"
              >
                Submit
              </Cta>
              {errors?.root?.error && (
                <Typography
                  color="error"
                  data-cy="forgot-password-status"
                  mt={2}
                >
                  {errors.root.error.message}
                </Typography>
              )}
            </Box>
          )}
        </form>
      )}
    </Modal>
  )
}

InternalForgotPassword.propTypes = {
  forgotPassword: PropTypes.func,
}
const mapStateToProps = () => {
  return {}
}
const mapDispatchToProps = (dispatch) => {
  return {
    forgotPassword: (email, actions) => {
      dispatch(doForgotPassword(email, actions))
    },
  }
}
const ForgotPassword = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalForgotPassword)

export default ForgotPassword
